import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import React, { useState, useEffect, useRef } from 'react';
import ConsultationModal from '../ConsultationModal';

import './index.css';

const Navbar = () => {
    const [addClass, setAddClass] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [activeSection, setActiveSection] = useState('');
    const [modalOpen, setModalOpen] = useState(false);

    const toggle = () => setAddClass(prev => !prev);
    const toggleMenu = () => setShowMenu(prev => !prev);

    const menuActive = showMenu ? 'is-active' : '';
    const burgerActive = showMenu ? 'is-active' : '';


    return (
        <div className="blockhash-nav">
            <nav className='navbar navbar-expand-lg sidenav' id="sidenav-1" data-mdb-hidden="false">
                <div className='container-fluid'>
                    <div className="inner-container">
                        <Link className='navbar-brand' to='/'><img src={require('../../static/images/logo.png')} alt='' /></Link>
                        <button
                            type='button'
                            aria-expanded='false'
                            data-toggle='collapse'
                            aria-label='Toggle navigation'
                            data-target='#navbarSupportedContent'
                            aria-controls='navbarSupportedContent'
                            className={`navbar-toggler ${burgerActive}`} onClick={toggleMenu}
                        >
                            <img className='defult-img' src={require('../../static/images/mobile-menu.png')} alt='' />
                            {/* <img className='close-img' src={require('../../static/images/mobile-menu.png')} alt='' /> */}
                        </button>
                        <div className={`collapse navbar-collapse nav-links clearfix ${menuActive}`} id='navbarSupportedContent'>
                            <ul className='navbar-nav sidenav-menu'>
                                <li className='nav-item'>
                                    <HashLink className='nav-link' smooth to='#about'>about</HashLink>
                                </li>
                                <li className='nav-item'>
                                    <HashLink className='nav-link' smooth to='#services'>Services</HashLink>
                                </li>
                                <li className='nav-item'>
                                    <HashLink className='nav-link' smooth to='#testimonials'>Testimonials</HashLink>
                                </li>
                                <li className='nav-item'>
                                    <HashLink className='nav-link' smooth to='#book-an-appointment'>Contact</HashLink>
                                </li>
                            </ul>
                            <div className='right-social-area-header'>
                                <a href='tel:+12138748309' className='tel-num'>+1 (213) 874-8309</a>
                                <button className='btn-get-started' onClick={() => setModalOpen(true)}>Free AI Consultation</button>
                            </div>
                            <ConsultationModal open={modalOpen} onClose={() => setModalOpen(false)} />
                        </div>
                    </div>
                </div>
            </nav>
            {/* <div className="whatsapp-swipe">
                <ul>
                    <li><a href="https://dexscreener.com/solana/2GCKQBYot4uFyauVJvcZhiQP8gXgiNQJuYVAo6SVeUti" target="_blank" className="whatsapp-icon" rel="nofollow noopener"></a></li>
                    <li><a href="https://raydium.io/swap/?inputMint=sol&outputMint=2GCKQBYot4uFyauVJvcZhiQP8gXgiNQJuYVAo6SVeUti" target="_blank" className="skype-icon" rel="nofollow noopener"></a></li>
                </ul>
            </div> */}
        </div>
    );
}
export default Navbar;